import React from 'react';
import { useFieldController } from '../../../../helpers/formManager';
import { fieldPathBuilders } from '../../shared/configs/acceptanceForm';
import Field from '../../shared/ui/Field';

const createFieldName = fieldPathBuilders.desk.isHoliday;

const TakeDeskHoliday = ({ deskIndex, disabled }) => {
  const { field } = useFieldController({
    name: createFieldName(deskIndex),
    defaultValue: false,
  });

  return (
    <Field.Memoized
      type={Field.types.checkbox}
      checked={field.value}
      onChange={field.onChange}
      disabled={disabled}
    >
      Праздничные дни
    </Field.Memoized>
  );
};

export default TakeDeskHoliday;
